export default __webpack_public_path__ + "static/sizzle_mobile-a71d70b5ccf5927f3e50e01e3d8fa0cc.mp4";